<template>
    <div class="gs-billing-detail">
        <div class="gs-billing-detail__card">
          <div class="gs-billing-detail__grid">
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_analytics_product_name')
                }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.product_name }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_analytics_price_point')
                }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.price_point_name }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_analytics_gateway')
                }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.gateway }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_transaction_id_gateway') }})</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.gateway_transaction_id }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_date_and_time') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.formatted_date_time }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_refund_period') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.product_refund_period }} {{
                    $t('frontend_analytics_days') }}</label>
            </div>

            <div v-if="purchase.recurring_billing" class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_recurring_bill') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.recurring_billing }}</label>
            </div>
            <div v-else class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_recurring_bill') }}</label>
                <label class="text-sm text-grey-700 mb-2">N/A</label>
            </div>

            <div v-if="purchase.recurring_billing && purchase.payments_left && purchase.payments_left != 99999999999"
                class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_analytics_payments_left') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.payments_left }}</label>
            </div>
          </div>
        </div>
    </div>
</template>
<style scoped>
.gs-billing-detail__card {
  padding: 20px 24px;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-sm);
}

.gs-billing-detail__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 20px;
}

.gs-billing-detail__field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.gs-billing-detail__field label:first-child {
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.gs-billing-detail__field label:last-child {
  overflow-wrap: anywhere;
  color: var(--gs-foreground);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .gs-billing-detail__card {
    padding: 16px;
  }

  .gs-billing-detail__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .gs-billing-detail__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
<script>
export default {
    props: {
        purchase: {
            required: true
        },
    }
}
</script>
